import { createSlice } from "@reduxjs/toolkit";
import { ISustainingState } from "../../pages/machines/sustaining/type";

const initialState: ISustainingState = {
    data: null,
    pageSize: 0,
    pageNumber: 0,
    totalCount: 0,
    showLoading: {
        sourceAction: "",
        state: false,
    },
    isLoading: false,
    isSuccess: false,
    sustainingDetails: null,
};

export const sustainingSlice = createSlice({
    name: "sustaining",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            const { sourceAction, isLoading, isSuccess } = action.payload;
            state.showLoading = {
                sourceAction: sourceAction,
                state: true,
            };
            state.isLoading = isLoading ? isLoading : false;
            state.isSuccess = isSuccess ? isSuccess : false;
        },
        resetLoading: (state, action) => {
            const { isLoading, isSuccess } = action.payload;
            state.showLoading = {
                sourceAction: "",
                state: false,
            };
            state.isLoading = isLoading ? isLoading : false;
            state.isSuccess = isSuccess ? isSuccess : false;
        },
        replaceSustaining: (state, action) => {
            const { data, pageSize, pageNumber, totalCount } = action.payload;
            state.data = data;
            state.pageSize = pageSize;
            state.pageNumber = pageNumber;
            state.totalCount = totalCount;
        },
        addSustaining: (state, action) => {
            const { localID, data } = action.payload;
            if (localID !== undefined && localID >= 0 && state.data) {
                state.data[localID].skuDTO = data;
            }
            state.sustainingDetails = data;
        },
        updateSustaining: (state, action) => {
            const { localID, data } = action.payload;
            if (localID !== undefined && localID >= 0 && state.data) {
                state.data[localID].skuDTO = data;
            }
            state.sustainingDetails = data;
        },
        setSustainingDetailsOwner: (state, action) => {
            const { localID, data } = action.payload;
            if (localID !== undefined && localID >= 0 && state.data) {
                state.data[localID].ownerAlias = data;
            }
            state.sustainingDetails = data;
        },
        setSustainingDetails: (state, action) => {
            state.sustainingDetails = action.payload.data;
        },
    },
});

export const sustainingActions = sustainingSlice.actions;
export default sustainingSlice.reducer;
